<template>
  <div class="satisfaction bg-w">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>满意度调查
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div v-if="notFound">
      <div class="content ub ub-ac">
        <div class="contentInfo ub-f1">
          <div class="title ft14 col-33">{{data.title}}</div>
          <div class="ft12 ub info-item">
            <span class="col-66">调查时间：</span>
            <p class="ft-wet ub-f1">
              {{data.start | formatDate('yyyy-MM-dd')}}至
              {{data.end | formatDate('yyyy-MM-dd')}}
            </p>
          </div>
          <div class="ft12 ub info-item">
            <span class="col-66">调查范围：</span>
            <p class="ft-wet ub-f1">{{data.range}}</p>
          </div>
          <div class="ft12 ub info-item">
            <span class="col-66">物业区域数：</span>
            <p class="ft-wet ub-f1">{{data.total}}</p>
          </div>
        </div>
        <div ref="echarsDemo" class="echarsDemo"></div>
      </div>
      <div class="footer">
        <div class="ub ub-ac">
          <div class="ft12 footer-label">完成进度</div>
          <div class="ub-f1">
            <el-progress :stroke-width="8" :show-text="false" :percentage="data.percentage"></el-progress>
          </div>
          <div class="footer-item col-66 ft12" style="width:170px">
            <svg-icon style="color:#0f77f2;margin:0 2px" iconClass="finish"></svg-icon>
            完成率{{data.percentage}}%
          </div>
        </div>
        <div class="ub ub-ac">
          <div class="ft12 footer-label">调查进度</div>
          <div class="ub-f1">
            <el-progress :stroke-width="8" :show-text="false" :percentage="data.percentDay"></el-progress>
          </div>
          <div class="footer-item col-66 ft12" style="width:170px">
            <svg-icon style="color:#0f77f2;margin:0 2px" iconClass="timer"></svg-icon>
            已过{{data.alreadyDay}}天，剩余
            <span class="col-red">{{data.sholdDay}}</span>天
          </div>
        </div>
      </div>
    </div>
    <div v-show="!notFound" class="brother">
      <div>
        <svg-icon icon-class="NoWork" class="iconStyle"></svg-icon>
        <br />暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { mapState } from 'vuex';
import { HomePageControllerSvr } from '@/service/HomePageControllerSvr/HomePageControllerSvr';

export default {
  components: {},
  props: {},
  computed: {
    ...mapState(['token']),
    mainTitle: () => {
      return commonTitle;
    }
  },
  data() {
    return {
      data: {},
      notFound: false
    };
  },
  created() {
    this.HomePageControllerSvr = new HomePageControllerSvr();
  },
  mounted() {
    this.getData();
  },
  methods: {
    jumpMore() {
      this.$router.push('/surveyMge');
    },
    getData() {
      this.HomePageControllerSvr.SurveyStatistics(this.token).then(res => {
        this.data = res;
        if (this.data) {
          this.notFound = true;
          this.data.range = res.range.slice(1, -1);
          this.data.percentage = Math.round((res.overNum / res.total) * 100);
          let start = new Date(
            this.data.start.split('T')[0].replace(/-/g, '/')
          );
          let now = new Date(); //获得当前日期
          let end = new Date(this.data.end.split('T')[0].replace(/-/g, '/')); //开始的日期截取年月日
          const endTime = end.getTime();
          const starTime = start.getTime();
          const nowTime = now.getTime();
          const totalDay = parseInt(
            (endTime - starTime) / (1000 * 60 * 60 * 24)
          );
          //alert('总天数' + totalDay);
          const alreadyDay = parseInt(
            (nowTime - starTime) / (1000 * 60 * 60 * 24)
          );
          //alert('已过天数' + alreadyDay);
          const sholdDay = parseInt(
            (endTime - nowTime) / (1000 * 60 * 60 * 24)
          );
          //alert('剩余天数' + sholdDay);//暂时处理为    负数时置为0天

          this.data.alreadyDay = alreadyDay;
          //计算已过天数百分比
          if (alreadyDay >= totalDay) {
            this.data.percentDay = 100;
            this.data.sholdDay = 0;
          } else {
            this.data.percentDay = Math.round((alreadyDay / totalDay) * 100);
            this.data.sholdDay = sholdDay;
          }

          this.getEchar(this.$refs.echarsDemo);
        }
      });
    },
    getEchar(dom) {
      //this.data.evaluationLevel  {key:value}
      let legendName = [];
      let Chartdata = [];
      const keyvalue = this.data.evaluationLevel; //{ 满意: 10, 不满意: 20, 非常不满意: 30 };
      for (const key in keyvalue) {
        legendName.push(key);
        Chartdata.push({ value: keyvalue[key], name: key });
      }
      let ChartTips = '满意度';
      if (!legendName.length) {
        ChartTips = '暂无数据';
      }
      let echarDom = this.$echarts.init(dom);
      let option = {
        backgroundColor: '',
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {d}% <br/> {c}件'
        },
        graphic: {
          elements: [
            {
              type: 'text',
              style: {
                text: ChartTips,
                x: 100,
                y: 100,
                textAlign: 'center',
                fill: '#333333',
                font: '16px "MicrosoftYaHei", sans-serif '
              },
              left: '48px',
              top: 'center'
            }
          ]
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: 'center',
          itemWidth: 10,
          itemHeight: 10,
          align: 'left',
          textStyle: {
            fontSize: 14,
            color: '#000'
          },
          data: legendName
        },
        series: [
          {
            type: 'pie',
            radius: ['35px', '50px'],
            center: ['70px', '50%'],
            color: [
              '#67aafe',
              '#0f77f2',
              '#ffb400',
              '#F8456B',
              '#00FFFF',
              '#4AEAB0'
            ],
            data: Chartdata,
            labelLine: {
              normal: {
                show: false,
                length: 20,
                length2: 20,
                lineStyle: {
                  color: '#12EABE',
                  width: 2
                }
              }
            },
            label: {
              normal: {
                show: false,
                formatter: '{c|{c}}\n{hr|}\n{d|{d}%}',
                rich: {
                  b: {
                    fontSize: 20,
                    color: '#12EABE',
                    align: 'left',
                    padding: 4
                  },
                  hr: {
                    borderColor: '#12EABE',
                    width: '100%',
                    borderWidth: 2,
                    height: 0
                  },
                  d: {
                    fontSize: 20,
                    color: '#fff',
                    align: 'left',
                    padding: 4
                  },
                  c: {
                    fontSize: 20,
                    color: '#fff',
                    align: 'left',
                    padding: 4
                  }
                }
              }
            }
          }
        ]
      };
      echarDom.setOption(option);
    }
  }
};
</script>
<style lang="scss" scoped>
.satisfaction {
  width: 100%;
  height: 295px;
  overflow: hidden;
  .brother {
    .iconStyle {
      font-size: 100px;
      padding-bottom: 20px;
    }
    height: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
      text-align: center;
    }
  }
  .content {
    .echarsDemo {
      height: 140px;
      margin-right: 10px;
      width: 250px;
    }
    .contentInfo {
      width: calc(50% - 10px);
      min-height: 140px;
      padding: 15px 20px;
      .title {
        border-left: 4px solid #0f77f2;
        padding-left: 8px;
      }
      .ft-wet {
        font-weight: 600;
        word-break: break-word;
      }
      .info-item {
        margin-top: 10px;
      }
    }
  }
  .footer {
    height: 70px;
    margin: 0 10px;
    border-top: 1px solid #e2e2e2;
    & > div {
      height: 35px;
    }
    .footer-label {
      margin-right: 10px;
    }
    .footer-item {
      width: 130px;
      margin: 0 10px;
    }
  }
}
</style>